// Port of api/fuel/app/classes/insights/games/timeline.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'timeline',
	priority: 8,
	types: [Constants.TYPE_USER],
	requires: ['init'],
	run: function() {
		var firstTouch = this._data.first_touch || {}
		var years = {}
		var byType = {}

		var keys = Object.keys(firstTouch)
		for (var i = 0; i < keys.length; i++) {
			var ft = firstTouch[keys[i]]
			var year = parseInt(Util.date('Y', ft.date), 10)
			var typeKey = String(ft.type || '').toLowerCase()
			if (typeKey === 'own') typeKey = 'owned'
			if (typeKey === 'previously owned') typeKey = 'prevowned'

			if (!years[year]) years[year] = 0
			years[year]++

			if (!byType[year]) {
				byType[year] = {
					played: 0,
					rated: 0,
					owned: 0,
					prevowned: 0,
					wishlisted: 0
				}
			}

			if (byType[year][typeKey] !== undefined) byType[year][typeKey]++
		}

		var yearKeys = Object.keys(years).map(Number).sort(function(a, b) { return a - b })
		var yearsArr = []
		for (var y = 0; y < yearKeys.length; y++) yearsArr.push({ year: yearKeys[y], count: years[yearKeys[y]] })

		var running = 0
		var byTypeArr = []
		for (var bt = 0; bt < yearKeys.length; bt++) {
			var yy = yearKeys[bt]
			running += byType[yy].owned + byType[yy].prevowned + byType[yy].played + byType[yy].rated + byType[yy].wishlisted
			byTypeArr.push({
				year: yy,
				played: byType[yy].played,
				rated: byType[yy].rated,
				owned: byType[yy].owned,
				prevowned: byType[yy].prevowned,
				wishlisted: byType[yy].wishlisted,
				total: running
			})
		}

		return {
			timeline: {
				years: yearsArr,
				byType: byTypeArr
			}
		}
	}
})
